<template>
    <h3 class="titlecount">Contact</h3>
    <p><br /></p>
    <div class="custom-grid">
        <div class="flex-float flex-6">
            <label>Personal title<em>*</em></label>
            <span class="wpcf7-form-control-wrap personaltitle not-validated">
                <select
                    v-model="contactModel.title"
                    name="personaltitle"
                    class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                    aria-required="true"
                    aria-invalid="false"
                >
                    <option>---</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Prof.">Prof.</option>
                    <option value="Dr.">Dr.</option>
                </select>
            </span>
        </div>
        <div class="flex-float flex-6">
            <label>Full name<em>*</em></label>
            <span class="wpcf7-form-control-wrap fullname not-validated">
                <input
                    v-model="contactModel.full_name"
                    type="text"
                    name="fullname"
                    size="40"
                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                    aria-required="true"
                    aria-invalid="false"
                />
            </span>
        </div>
    </div>
    <div class="custom-grid">
        <div class="flex-float flex-6">
            <label>Job title<em>*</em></label>
            <span class="wpcf7-form-control-wrap jobtitle not-validated">
                <input
                    v-model="contactModel.job_title"
                    type="text"
                    name="jobtitle"
                    size="40"
                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                    aria-required="true"
                    aria-invalid="false"
                />
            </span>
        </div>
        <div class="flex-float flex-6">
            <label>Phone<em>*</em></label>
            <span class="wpcf7-form-control-wrap contactphone not-validated">
                <input
                    v-model="contactModel.phone"
                    type="tel"
                    name="contactphone"
                    size="40"
                    class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel"
                    aria-required="true"
                    aria-invalid="false"
                />
            </span>
        </div>
    </div>
    <div class="custom-grid">
        <div class="flex-float flex-6">
            <label>Email<em>*</em></label>
            <span class="wpcf7-form-control-wrap contactemail not-validated">
                <input
                    v-model="contactModel.email"
                    type="email"
                    name="contactemail"
                    size="40"
                    class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                    aria-required="true"
                    aria-invalid="false"
                />
            </span>
        </div>
    </div>
</template>

<script>
import { contactModelDefaults } from "@/helpers/user";

export default {
    props: ["contact"],
    emits: ["update:contact"],
    data() {
        return {
            contactModel: contactModelDefaults(),
        };
    },
    mounted() {
        this.contactModel = this.contact;
    },
    watch: {
        contactModel: {
            handler(newValue, oldValue) {
                this.$emit("update:contact", newValue);
            },
            deep: true,
        },
    },
};
</script>

<style></style>
